import { useContext, useEffect, useState } from "react";

import Button from "antd/lib/button";
import Modal from "antd/lib/modal";
import { ModalProps } from "./types";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import styles from "./styles.module.scss";

//UI

export default function ModalComponent(props: ModalProps) {
  const { name, isOpen, onOk, onCancel, footerButtons, children } = props;
  const { intl } = useContext(TranslationContext);

  // const [_, forceUpdate] = useState(false);

  //  // 🧪 Додай перевірку перекладів:
  //  console.log("intl('ok'):", intl("ok"));
  //  console.log("intl('cancel'):", intl("cancel"));

  //    // Примусовий ререндер при зміні функції intl (наприклад, при зміні мови)
  // useEffect(() => {
  //   forceUpdate((prev) => !prev);
  // }, [intl]);

  const style =
    name === "isModalOpen" ? styles["modal-with-footer"] : styles["modal"];
  const showOkButton = name !== "isScan";

  return (
    <Modal
      className={style}
      open={isOpen}
      okText={intl("ok")}
      cancelText={intl("cancel")}
      onOk={onOk}
      onCancel={onCancel}
      destroyOnClose
      footer={
        showOkButton ? (
          footerButtons
        ) : (
          <Button key="cancel" onClick={onCancel}>
            {intl("cancel")}
          </Button>
        )
      }
    >
      {children}
    </Modal>
  );
}
